import { useState } from 'react';
import { FileTextTwoTone, IdcardTwoTone } from '@ant-design/icons';

import { mappingColumns } from '../companyContact/hook';
import { LOCATION_COLUMNS, LOCATION_COLUMNS_AG } from './constants';

import { sleep } from 'utils/delay';

export const useLocation = ({ propsData }) => {
  const [locationList, setLocationList] = useState(() => {
    return (propsData?.id ? [{ ...propsData }] : [])?.map((product) => {
      return { ...product, key: product?.id };
    });
  });

  const handleDeleteDataSource = (key) => {
    const filter = locationList.filter((item) => item?.key !== key);
    setLocationList(filter);
  };

  const addData = (contact) => {
    setLocationList((pre) => {
      const key = pre[pre?.length - 1]?.key ? pre[pre?.length - 1]?.key + 1 : 1;

      return [...pre, { ...contact, key }];
    });
  };

  const editData = (currentContact) => {
    setLocationList((pre) => {
      return pre?.map((item) => {
        return item?.key === currentContact?.key
          ? {
              ...currentContact,
              id: propsData?.id ? item?.key : null,
            }
          : item;
      });
    });
  };

  return {
    locationList,
    addData,
    editData,
    handleDeleteDataSource,
  };
};

export const useLocationColumns = (hiddenFields = []) => {
  const columns = mappingColumns(LOCATION_COLUMNS, hiddenFields);
  const filter = columns?.filter(
    (item) => !hiddenFields.includes(item?.dataIndex)
  );

  return {
    columns: filter,
  };
};

export const useGetLocationColumnsDef = ({
  setVisibleAssociateContact,
  setVisibleAssociateCertificate,
}) => {
  const columnsDefs = [
    {
      field: '',
      checkboxSelection: true,
      filter: false,
      suppressMenu: true,
      width: 50,
      resizable: true,
    },
    ...LOCATION_COLUMNS_AG,
    {
      dataType: 'string',
      headerName: 'Associated Contacts',
      fieldName: 'associateContactIds',
      fieldNameCamelCase: 'associateContactIds',
      allowFilter: true,
      allowSort: true,
      width: 180,
      cellRenderer: ({ data }) => (
        <RenderAssociatedContacts
          data={data}
          setVisibleAssociateContact={setVisibleAssociateContact}
        />
      ),
      resizable: true,
    },
    {
      dataType: 'string',
      headerName: 'Associated Certificates',
      fieldName: 'associateCertificateIds',
      fieldNameCamelCase: 'associateCertificateIds',
      allowFilter: true,
      allowSort: true,
      width: 200,
      cellRenderer: ({ data }) => (
        <RenderAssociatedCertificates
          data={data}
          setVisibleAssociateCertificate={setVisibleAssociateCertificate}
        />
      ),
      resizable: true,
    },
  ];

  return { columnsDefs };
};

export const RenderAssociatedContacts = (props) => {
  const { data, setVisibleAssociateContact } = props;

  return (
    <>
      {data?.associateContactIds?.length > 0 ? (
        <IdcardTwoTone
          style={{ fontSize: 16, cursor: 'pointer' }}
          onClick={async () => {
            await sleep(100);
            setVisibleAssociateContact(true);
          }}
        />
      ) : (
        ''
      )}
    </>
  );
};

export const RenderAssociatedCertificates = (props) => {
  const { data, setVisibleAssociateCertificate } = props;

  return (
    <>
      {data?.associateCertificateIds?.length > 0 ? (
        <FileTextTwoTone
          style={{ fontSize: 16, cursor: 'pointer' }}
          onClick={async () => {
            await sleep(100);
            setVisibleAssociateCertificate(true);
          }}
        />
      ) : (
        ''
      )}
    </>
  );
};
